document.querySelectorAll('.mvng_arcr_inp').forEach(function(mvgip){
    mvgip.addEventListener('click',function(mvgie){
      var mvg = mvgie.currentTarget.getAttribute("id");
      document.querySelectorAll(".fdl_descr:has(#" + mvg + ")")[0].setAttribute("data-fdl_disp","true");
      setTimeout(() => {
      document.querySelectorAll(".fdl_descr_inner:has(#" + mvg + ") .fld_descr_imgs_A")[0].setAttribute("data-disp","true");
      setTimeout(() => {
        document.querySelectorAll(".fdl_descr_inner:has(#" + mvg + ") .fld_descr_imgs_B")[0].setAttribute("data-disp","true");
        setTimeout(() => {
          document.querySelectorAll(".fdl_descr_inner:has(#" + mvg + ") .fld_descr_imgs_C")[0].setAttribute("data-disp","true");
          setTimeout(() => {
            document.querySelectorAll(".fdl_descr_inner:has(#" + mvg + ") .fdl_descr_content")[0].setAttribute("data-ldcnt","true");
          },1000);
        },1000);
      },1000);
    },1000);
    });
});

function clm_cls_rdo(mvg_elem){
  document.querySelectorAll(".fdl_descr_inner:has(#" + mvg_elem + ") .fdl_descr_content")[0].setAttribute("data-ldcnt","false");
  if(document.querySelectorAll(".fdl_descr_inner:has(#" + mvg_elem + ") .fld_descr_imgs_D")[0]){
    document.querySelectorAll(".fdl_descr_inner:has(#" + mvg_elem + ") .fld_descr_imgs_D")[0].setAttribute("data-disp","false");
  };
  document.querySelectorAll(".fdl_descr_inner:has(#" + mvg_elem + ") .fld_descr_imgs_C")[0].setAttribute("data-disp","false");
  document.querySelectorAll(".fdl_descr_inner:has(#" + mvg_elem + ") .fld_descr_imgs_B")[0].setAttribute("data-disp","false");
  document.querySelectorAll(".fdl_descr_inner:has(#" + mvg_elem + ") .fld_descr_imgs_A")[0].setAttribute("data-disp","false");
  document.querySelectorAll(".fdl_descr:has(#" + mvg_elem + ")")[0].setAttribute("data-fdl_disp","false");
  document.getElementById(mvg_elem).checked = false;
};

document.querySelectorAll('.fdl_descr_content_btn').forEach(function(extb){
  extb.addEventListener('click',function(extb_ev){
    var ex_prn = extb_ev.currentTarget.getAttribute("data-extb_prn");
    var ex_lnk = extb_ev.currentTarget.getAttribute("data-extb_lnk");
    document.querySelectorAll(".fdl_descr_inner:has(#" + ex_prn + ") .fld_descr_imgs")[0].scrollIntoView({ behavior: "smooth", block: "start"});
    setTimeout(() => {
      document.querySelectorAll(".fdl_descr_inner:has(#" + ex_prn + ") .fld_descr_imgs_D")[0].setAttribute("data-disp","true");
      setTimeout(() => {
        window.location.href = ex_lnk;
      },1300);
    },500);
  });
});